document.addEventListener("DOMContentLoaded", function () {
  let currentStep = 0,
    confettiTriggered = false;

  // Modal Functionality Start
  let quizModal = document.getElementById("quiz-modal");
  let newsletter = document.getElementsByClassName("newsletter");
  let announcementBar = document.getElementsByClassName(
    "announcement-bar-section"
  );
  let navBar = document.getElementsByClassName("shopify-section-header-sticky");
  let closeModalBtn = document.getElementById("close-modal");
  let bannerButton = document.querySelector("a[href='#ui89-io']");

  // Steps Handle Start
  const steps = document.querySelectorAll(".quiz-step");
  const prevBtn = document.getElementById("prev-btn");
  const nextBtn = document.getElementById("next-btn");
  const restartQuizBtn = document.getElementById("restart-quiz");
  const addAllToCartBtn = document.querySelector(".add-all-to-cart");
  const downloadPdfBtn = document.getElementById("download-pdf");
  const signUpBtn = document.getElementById("sign-up-quiz");

  bannerButton &&
    bannerButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default action (if it's a link)
      quizModal.classList.add("show");
      newsletter[0].style.display = "none";
      announcementBar[0].style.zIndex = "-1";
      navBar[0].style.zIndex = "-1";
      document.body.classList.add("modal-open"); // Disable scrolling
    });
  closeModalBtn.addEventListener("click", function () {
    quizModal.classList.remove("show");
    newsletter[0].style.display = "block";
    announcementBar[0].style.zIndex = "3";
    navBar[0].style.zIndex = "4";
    document.body.classList.remove("modal-open");
    sessionStorage.removeItem("generated-dn");
    restartQuiz();
  });
  window.addEventListener("click", function (event) {
    if (event.target === quizModal) {
      quizModal.classList.remove("show");
    }
  });
  // Modal Functionality End

  // User Option value set
  var userFilters = {
    age: "",
    gender: "",
    weight: "",
    goal: "",
    activity: "",
    condition: "",
    diet: "",
    firstName: "",
    lastName: "",
    email: "",
  };

  const updateStep = () => {
    prevBtn.disabled = currentStep === 0;
    nextBtn.disabled = currentStep === steps.length;
  };

  async function fetchShopifySecrets() {
    try {
      const response = await fetch(
        "https://diet-quiz-shopify-proxy.info-debataenterprise.workers.dev/fetch-token",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch Shopify secrets");

      const data = await response.json();
      window.shopifyAccessToken = data.shopifyAccessToken;
      window.storefrontAccessToken = data.storefrontAccessToken;
    } catch (error) {
      console.error("Error fetching Shopify secrets:", error);
    }
  }

  async function generateAndFetchProducts(userFilters) {
    try {
      // fetch the secret for shopify api secrets
      await fetchShopifySecrets();
      await window.generateDietPlan(userFilters);

      await window.fetchProducts(userFilters);
    } catch (error) {
      console.error(
        "Error in generating diet plan or fetching products:",
        error
      );
    }
  }
  function showLoader() {
    const loaderScreen = document.getElementById("loading-screen-diet-quiz");
    loaderScreen.style.display = "flex";
    document.body.classList.add("show-background");

    const messages = [
      "⏳ Analyzing Your Diet...",
      "🥑 Finding the Best Nutrition Plan...",
      "🍎 Picking Healthy Ingredients...",
      "🍽️ Customizing Your Meal Plan...",
    ];

    let index = 0;

    function updateText() {
      loaderText.innerText = messages[index];
      loaderText.style.animation = "none";
      void loaderText.offsetWidth;
      loaderText.style.animation = "popText 2.2s ease-in-out";
      index = (index + 1) % messages.length;
    }

    updateText();
    const textInterval = setInterval(updateText, 2200);
    setTimeout(() => {
      clearInterval(textInterval);
      hideLoader();
    }, 8000);
  }

  function hideLoader() {
    document.body.classList.remove("show-background"); // Remove white background
    const loaderScreen = document.getElementById("loading-screen-diet-quiz");
    loaderScreen.style.opacity = "0"; // Fade out
    setTimeout(() => {
      loaderScreen.style.display = "none";
    }, 500);

    const name = document.getElementById("name").value.trim();
    let username = name.split(" ")[0];

    const result = document.getElementById("result-h2-quiz");
    const goalResult = document.getElementById("goal-result");
    const typingElement = document.querySelector(".typing-effect");

    // 🎉 Set result text with username
    result.innerHTML = `🎉 Congratulations, <span style="color: green;">${username}</span>!`;
    result.style.opacity = "0"; // Hide at first
    goalResult.style.opacity = "0"; // Hide at first

    // based on the goal show the second line message
    const goal = userFilters.goal;
    const goalMessages = {
      weight_loss:
        "Burn fat, boost energy, and stay full with a personalized, science-backed plan just for you!",
      muscle_gain:
        "Fuel your workouts the right way! Your expert-designed muscle-building plan is ready!",
      "overall-health":
        "Healthy eating made easy! Your science-backed plan is here to help you feel your best every day!",
      health_management:
        "Nourish your body the right way—science-backed, expert-curated, and tailored to your health goals!",
      default:
        "Here’s your science-backed diet plan to achieve your health goals!",
    };

    // 🌟 Set goal-based message
    goalResult.innerHTML =
      goalMessages[userFilters.goal] || goalMessages["default"];

    setTimeout(() => {
      result.style.transition = "opacity 1s ease-in-out";
      goalResult.style.transition = "opacity 1s ease-in-out";
      result.style.opacity = "1";
      goalResult.style.opacity = "1";
    }, 500);
    setTimeout(() => {
      typingElement.style.visibility = "visible";
      typingElement.style.animation =
        "typing 2s steps(20, end) forwards, blink .8s infinite";
    }, 700);

    restartQuizBtn.style.display = "block";
    addAllToCartBtn.style.display = "block";
    function formatTitle(text) {
      return text
        .split("_") // Split by underscore
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(" "); // Join with space
    }

    document.getElementById("show-goal").textContent = formatTitle(
      userFilters.goal
    )
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
    const calculateCalorieResult = window.calculateCalories(
      userFilters.weight,
      userFilters.age,
      userFilters.gender,
      userFilters.activity,
      userFilters.goal
    );
    document.getElementById(
      "show-calories"
    ).textContent = ` ${calculateCalorieResult.calories} kcal`;
    document.getElementById(
      "show-dietType"
    ).textContent = ` ${calculateCalorieResult.preferredDiet}`;
    ("High-Protein & Balanced");
    document.getElementById(
      "show-protein"
    ).textContent = `${calculateCalorieResult.macros.protein}`;
    document.getElementById(
      "show-carbs"
    ).textContent = `${calculateCalorieResult.macros.carbs}`;
    document.getElementById(
      "show-fats"
    ).textContent = `${calculateCalorieResult.macros.fat}`;
    setTimeout(() => {
      if (!confettiTriggered) {
        confettiTriggered = true;
        confetti({
          particleCount: 120,
          spread: 80,
          startVelocity: 40,
          origin: { y: 0.5 },
          scalar: 0.8,
        }).catch((err) => console.error("Confetti error:", err));
      }
    }, 500);
  }

  const nextStep = async () => {
    let quizContent = document.getElementById("quiz-container");
    let modalContent = document.querySelector(".modal-content");
    steps[currentStep].classList.remove("active");
    currentStep++;
    if (currentStep < steps.length) {
      quizContent.style.maxWidth = "86rem";
      setTimeout(() => {
        steps[currentStep].classList.add("active");
      }, 50);
    } else {
      showLoader();
      generateAndFetchProducts(userFilters);
      modalContent.style.alignItems = "unset";
      quizContent.style.maxWidth = "1200px";
      quizContent.style.margin = "18px auto";

      nextBtn.style.display = "none";
      prevBtn.style.display = "none";
      restartQuizBtn.style.display = "block";
      addAllToCartBtn.style.display = "block";
      document.getElementById("result").style.display = "block";
      // Send Customer email to shopify
      try {
        window.sendCustomerDataToShopify(userFilters);
      } catch (error) {
        console.error("Failed to send customer data:", error);
      }
      // setTimeout(() => {
      //   hideLoader(); // Hide loader, then trigger confetti
      // }, 3000);
    }
    updateStep();
  };
  const restartQuiz = () => {
    currentStep = 0;
    document.getElementById("result").style.display = "none";
    steps.forEach((step) => step.classList.remove("active"));
    steps[0].classList.add("active");
    document.getElementById("name").value = "";
    document.getElementById("email").value = "";

    // Remove 'selected' class from all options
    document.querySelectorAll(".option-btn.selected").forEach((option) => {
      option.classList.remove("selected");
    });
    document
      .querySelectorAll(".checkbox-container input[type='checkbox']")
      .forEach((checkbox) => {
        checkbox.checked = false;
      });
    document.getElementById("diet-type-select").selectedIndex = 0;
    let quizContent = document.getElementById("quiz-container");
    let modalContent = document.querySelector(".modal-content");
    modalContent.style.alignItems = "center";
    quizContent.style.maxWidth = "86rem";
    nextBtn.style.display = "block";
    prevBtn.style.display = "block";
    restartQuizBtn.style.display = "none";
    addAllToCartBtn.style.display = "none";
    prevBtn.disabled = true;
    userFilters = {};
  };

  // Ensure the card does NOT flip on page load
  document.getElementById("couponCode").addEventListener("click", function () {
    navigator.clipboard.writeText(this.innerText).then(() => {
      document.getElementById("offerCard").classList.add("flip"); // Flip the card after copying
    });
  });

  document.getElementById("couponCode").addEventListener("click", function () {
    navigator.clipboard.writeText("QUIZBONUS100");
    document.getElementById("copiedMessage").style.display = "block";

    // Hide copied message after 2 seconds
    setTimeout(function () {
      document.getElementById("copiedMessage").style.display = "none";
    }, 2000);
  });

  function startCountdown() {
    const countdownElement = document.getElementById("countdown");

    // Get stored expiration time or set a new one
    let expirationTime = localStorage.getItem("offerExpiration");
    if (!expirationTime) {
      // Set new expiration time (48 hours from now)
      expirationTime = Date.now() + 48 * 60 * 60 * 1000;
      localStorage.setItem("offerExpiration", expirationTime);
    }

    function updateTimer() {
      const now = Date.now();
      let remainingTime = expirationTime - now;

      if (remainingTime <= 0) {
        countdownElement.textContent = "⏳ Offer Expired!";
        localStorage.removeItem("offerExpiration");
        return;
      }

      let hours = Math.floor(remainingTime / (1000 * 60 * 60));
      let minutes = Math.floor(
        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

      countdownElement.textContent =
        (hours < 10 ? "0" : "") +
        hours +
        ":" +
        (minutes < 10 ? "0" : "") +
        minutes +
        ":" +
        (seconds < 10 ? "0" : "") +
        seconds;
    }

    updateTimer(); // Update immediately
    setInterval(updateTimer, 1000); // Update every second
  }

  startCountdown();

  setTimeout(() => {
    document.getElementById("community").classList.add("active");
  }, 2000);

  const prevStep = () => {
    steps[currentStep].classList.remove("active");
    currentStep--;
    steps[currentStep].classList.add("active");
    updateStep();
  };
  // Steps Handle End

  //  Step 1: Select Age Group
  const stepsData = [
    { attribute: "data-gender", key: "gender" },
    { attribute: "data-goal", key: "goal" },
    { attribute: "data-activity", key: "activity" },
    { attribute: "data-condition", key: "condition" },
  ];

  stepsData.forEach((step) => {
    document.body.addEventListener("click", function (event) {
      if (event.target.hasAttribute(step.attribute)) {
        userFilters[step.key] = event.target.getAttribute(step.attribute);
        document
          .querySelectorAll(`[${step.attribute}]`)
          .forEach((el) => el.classList.remove("selected"));
        event.target.classList.add("selected");
        nextStep();
      }
    });
  });

  // document.getElementById("start-quiz").addEventListener("click", nextStep);
  prevBtn.addEventListener("click", prevStep);
  nextBtn.addEventListener("click", nextStep);

  // Initialize first step
  updateStep();

  const nameInput = document.getElementById("name");
  const nameContinueBtn = document.getElementById("name-continue");
  const ageContinueBtn = document.getElementById("age-continue");
  const emailContinueBtn = document.getElementById("email-continue");
  const weigthContinueBtn = document.getElementById("weight-continue");
  const conditionContinueBtn = document.getElementById("condition-continue");

  const nameInputHandler = () => {
    if (nameInput.value.trim() !== "") {
      nameContinueBtn.disabled = false;
      nameContinueBtn.classList.remove("quiz-disable-btn");
    } else {
      nameContinueBtn.disabled = true;
      nameContinueBtn.classList.add("quiz-disable-btn");
    }
  };
  const nameContinueBtnHandler = () => {
    const userName = nameInput.value.trim();
    if (userName) {
      const firstName = userName.split(" ")[0];
      const lastName = userName.split(" ")[1] || "";
      userFilters.firstName = firstName;
      userFilters.lastName = lastName;
      // go to gender option
      const genderStep = document.getElementById("gender-step");
      const genderStepHeading = genderStep.querySelector("h2");
      genderStepHeading.innerHTML = `Lovely to meet you <span style="color: green;">${firstName}</span>, what's your gender?`;
      document.getElementById("name-step").classList.remove("active");
      genderStep.classList.add("active");
      nextStep();
    }
  };
  const ageContinueBtnHandler = () => {
    let ageInput = document.getElementById("quiz-age");
    userFilters.age = ageInput.value.trim();
    const weightStep = document.getElementById("weight-step");
    document.getElementById("age-step").classList.remove("active");
    weightStep.classList.add("active");
    nextStep();
  };
  const conditionContinueBtnHandler = () => {
    let selectedConditions = [];

    // Get all checkboxes
    document
      .querySelectorAll('input[name="condition"]:checked')
      .forEach((checkbox) => {
        selectedConditions.push(checkbox.value);
      });

    userFilters.condition = selectedConditions;
    const dietStep = document.getElementById("diet-step");
    document.getElementById("conditions-step").classList.remove("active");
    dietStep.classList.add("active");
    nextStep();
  };
  const emailContinueBtnHandler = () => {
    const emailInput = document.getElementById("email");
    if (emailInput) {
      userFilters.email = emailInput.value.trim();
      const email = emailInput.value.trim();
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        alert("Please enter a valid email address.");
        return;
      } else nextStep();
    } else alert("Email is mandatory!");
  };

  // Age Slider Start
  function updateQuizDisplay(event) {
    let slider = event.target;
    let display = document.getElementById(slider.id + "-display");
    let tooltip = document.getElementById(slider.id + "-tooltip");

    display.innerText = slider.value; // Update displayed value
    tooltip.innerText = slider.value; // Update tooltip value
    tooltip.style.left = `${
      ((slider.value - slider.min) / (slider.max - slider.min)) * 100
    }%`; // Move tooltip
    tooltip.style.display = "block";
  }
  function hideTooltip(event) {
    let tooltip = document.getElementById(event.target.id + "-tooltip");
    tooltip.style.display = "none";
  }
  function addQuizEventHandlers() {
    const sliders = document.querySelectorAll(".quiz-slider");
    sliders.forEach((slider) => {
      slider.addEventListener("input", updateQuizDisplay);
      slider.addEventListener("touchend", hideTooltip); // Hide tooltip on mobile after touch
      slider.addEventListener("mouseleave", hideTooltip); // Hide tooltip when leaving mouse
    });
  }
  addQuizEventHandlers();
  // Age Slider End

  // Weight Wheel Start
  const wheelContainer = document.getElementById("wheelContainer");
  const wheel = document.getElementById("wheel");
  const nextButton = document.getElementById("nextButton");

  // Configuration
  const config = {
    min: 50,
    max: 100,
    step: 1,
    initialValue: 65,
  };

  // Generate values
  const values = [];
  for (let i = config.min; i <= config.max; i += config.step) {
    values.push(i.toString());
  }

  // Find initial index
  const initialIndex =
    values.findIndex((val) => parseInt(val) === config.initialValue) || 0;

  let currentIndex = initialIndex;
  const itemHeight = 52;

  // Render wheel items
  values.forEach((value, index) => {
    const item = document.createElement("div");
    item.className = "wheel-item";
    item.textContent = value;
    item.dataset.index = index;
    wheel.appendChild(item);
  });

  // Set initial position
  updatePosition(currentIndex);

  // Dragging variables
  let startY = 0;
  let startOffset = 0;
  let isDragging = false;

  // Update the selection and position
  function updatePosition(index) {
    const items = wheel.querySelectorAll(".wheel-item");
    items.forEach((item) => item.classList.remove("selected"));

    currentIndex = Math.max(0, Math.min(values.length - 1, index));
    const centerItem = wheel.querySelector(`[data-index="${currentIndex}"]`);

    if (centerItem) {
      centerItem.classList.add("selected");
      wheel.style.transform = `translateY(${54 - currentIndex * itemHeight}px)`;
    }

    // Update surrounding items to create a visual gradient effect
    items.forEach((item, idx) => {
      const distance = Math.abs(idx - currentIndex);
      item.style.opacity = distance > 2 ? 0.3 : 1 - distance * 0.2;
    });
  }

  // Get current selected value
  function getValue() {
    return parseInt(values[currentIndex]);
  }

  // checkbox control
  document
    .querySelectorAll('.checkbox-label input[type="checkbox"]')
    .forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        let label = this.closest(".checkbox-label");

        this.checked
          ? (label.style.borderColor = "#2E7D32")
          : (label.style.borderColor = "#ccc");
      });
    });

  // dropdown select handler
  document
    .getElementById("diet-type-select")
    .addEventListener("change", function () {
      userFilters.diet = this.value;
      const emailStep = document.getElementById("email-step");
      document.getElementById("diet-step").classList.remove("active");
      emailStep.classList.add("active");
      nextStep();
    });

  // Touch events
  wheelContainer.addEventListener("touchstart", handleStart, {
    passive: false,
  });
  wheelContainer.addEventListener("mousedown", handleStart, {
    passive: true,
  });

  document.addEventListener("touchmove", handleMove, { passive: true });
  document.addEventListener("mousemove", handleMove, { passive: true });
  document.addEventListener("touchend", handleEnd, { passive: true });
  document.addEventListener("mouseup", handleEnd, { passive: true });

  function handleStart(e) {
    e.preventDefault();
    isDragging = true;
    startY = e.type === "touchstart" ? e.touches[0].clientY : e.clientY;
    wheel.style.transition = "none";

    // Get current transform value
    const transform = window
      .getComputedStyle(wheel)
      .getPropertyValue("transform");
    const matrix = new DOMMatrix(transform);
    startOffset = matrix.m42; // This gets the Y translation value
  }

  function handleMove(e) {
    if (!isDragging) return;
    e.preventDefault();

    const currentY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;
    const diff = currentY - startY;

    // Move the wheel based on drag
    wheel.style.transform = `translateY(${startOffset + diff}px)`;
  }

  function handleEnd() {
    if (!isDragging) return;
    isDragging = false;

    // Get current transform
    const transform = window
      .getComputedStyle(wheel)
      .getPropertyValue("transform");
    const matrix = new DOMMatrix(transform);
    const translateY = matrix.m42;

    // Calculate the closest index
    const newIndex = Math.round((54 - translateY) / itemHeight);

    // Animate to the snapped position
    wheel.style.transition = "transform 0.3s ease";
    updatePosition(newIndex);
  }

  // Next button
  weigthContinueBtn.addEventListener("click", () => {
    const selectedValue = getValue();
    // Here you can handle what happens when Next is clicked
    userFilters.weight = selectedValue;
    const goalStep = document.getElementById("goal-step");
    document.getElementById("weight-step").classList.remove("active");
    goalStep.classList.add("active");
    nextStep();
  });

  // Add mouse wheel support
  wheelContainer.addEventListener(
    "wheel",
    (e) => {
      e.preventDefault();
      const direction = e.deltaY > 0 ? 1 : -1;
      wheel.style.transition = "transform 0.3s ease";
      updatePosition(currentIndex + direction);
    },
    { passive: true }
  );
  // Weight Wheel End

  nameInput.addEventListener("input", nameInputHandler);
  nameContinueBtn.addEventListener("click", nameContinueBtnHandler);
  ageContinueBtn.addEventListener("click", ageContinueBtnHandler);
  conditionContinueBtn.addEventListener("click", conditionContinueBtnHandler);
  emailContinueBtn.addEventListener("click", emailContinueBtnHandler);
  let cartCount = 0;
  window.totalProductsForDietQuiz =
    document.querySelectorAll(".product-card").length;

  //   update cart button
  const updateCartButton = () => {
    if (cartCount === window.totalProductsForDietQuiz) {
      addAllToCartBtn.textContent = `Proceed to Cart (${cartCount})`;
      addAllToCartBtn.addEventListener("click", function () {
        window.location.href = "/cart";
      });
    }
  };
  document.querySelectorAll(".add-to-cart").forEach((button) => {
    button.addEventListener("click", function () {
      let productId =
        this.closest(".product-card").getAttribute("data-variant-id");
      fetch(`/cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quantity: 1, id: productId.split("/").pop() }),
      })
        .then((response) => response.json())
        .then((data) => {
          cartCount++;
          updateCartButton();
          alert("Product added to cart!");
        })
        .catch((error) => console.error("Error adding to cart:", error));
    });
  });
  //   Add all to cart button functionality
  addAllToCartBtn.addEventListener("click", function () {
    let productIds = Array.from(document.querySelectorAll(".product-card")).map(
      (card) => card.getAttribute("data-variant-id")
    );

    let items = productIds.map((id) => ({
      id: id.split("/").pop(),
      quantity: 1,
    }));

    fetch(`/cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((data) => {
        cartCount = window.totalProductsForDietQuiz;
        updateCartButton();
        alert("All products added to cart!");
      })
      .catch((error) =>
        console.error("Error adding all products to cart:", error)
      );
  });

  signUpBtn.addEventListener("click", window.signupHandler);
  downloadPdfBtn.addEventListener("click", () =>
    window.printDesign("download")
  );
  restartQuizBtn.addEventListener("click", restartQuiz);
});
